export default __webpack_public_path__ + "images/a4ab1d9cce8276f3345df80d338ec331.png";